import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_USER_GROUP = createActionTypes('CREATE_USER_GROUP');
export const FETCH_USER_GROUP = createActionTypes('FETCH_USER_GROUP');
export const GET_USER_GROUP = createActionTypes('GET_USER_GROUP');
export const DELETE_USER_GROUP = createActionTypes('DELETE_USER_GROUP');
export const UPDATE_USER_GROUP = createActionTypes('UPDATE_USER_GROUP');
export const ALL_USERS_IN_USER_GROUP = createActionTypes('ALL_USERS_IN_USER_GROUP');
export const CREATE_BULK_USERS_TO_USER_GROUP = createActionTypes('CREATE_BULK_USERS_TO_USER_GROUP');
